import DeviceService from '../services/DeviceService';

export default {
    bind: function(el, binding, vnode) {

        let path = binding.value;

        DeviceService.getDeviceImage(path).then(response => {
            let image = btoa(
                new Uint8Array(response.data)
                    .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );

            el.src = `data:${response.headers['content-type']};base64, ${image}`;
        });
    },
    unbind() {}
}
